import React, { useState,useEffect } from "react";
import { Form, Table } from "react-bootstrap";

import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
import IconButton from "@material-ui/core/IconButton";
import SearchIcon from "@material-ui/icons/Search";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
// import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import Media from "react-media";
import Pagination from "rc-pagination";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { BottomNavigationMobile } from "../navigationSection/BottomNavigationMobile";
import { RightSideCountTop } from "../../superAdminComponents/superAdminAllComponent/superAdminReports/orderingReports/SuperAdminPendingOrderActivityReports";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import { Event_Reports } from "../../../store/actions/VendorReports/vendorReportsRestaurant";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import { ORDER_TYPE,PAYMENT_STATUS,PAYMENT_TYPE } from "../../../enums/OrderEnums";
import moment from "moment";
import { SortComponent } from "../../reusableComponents/SortAndFilterComponent/SortComponent";
import SelectFilter from '../../reusableComponents/selectFilter';
import BasicPagination from "../../Pagination/Pagination";
import { parse } from "date-fns";

function EventReports(props) {
  // console.log(props);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(10);
  const [dateQuery, setDateQuery] = useState({
    
  });
  const [state, setState] = useState({
    search: "",
  });
  const [anchorEl,setAnchorEl] = useState(null);
  const [restaurantReverse,setRestaurantReverse] = useState("");
  const [itemData, setitemData] = useState([]);

  const handleBatchChange = (pageNo) => {
    window.scrollTo(0, 0);
    var calcStart = pageNo * 10 - 10;
    setStart(calcStart);
    setEnd(pageNo * 10);
    setPage(pageNo);
  };

  const onDateChangeHandler = () => (data, type) => {
    setDateQuery(data);
  }

  const onSearchChange = (e) => {
    
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
    
  };

  const getData=()=>{
    props.Event_Reports(props.auth.user.accessToken,dateQuery);
  }

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (value) => (e) => {
    setRestaurantReverse(value);
    console.log(restaurantReverse);
    handleClose();
  };

  useEffect((async) => {
    const DateForm = {
      startDate : moment().format("YYYY-MM-DD"),
      endDate : moment().format("YYYY-MM-DD"),
    }
    if(!isEmpty(dateQuery)){
      getData(props.auth.user.accessToken,dateQuery.startDate === 'undefined' ? DateForm : dateQuery);
    }
    // props.Event_Reports(props.auth.user.accessToken);
    
  }, [dateQuery]);

  let tempdata = [];
  console.log(restaurantReverse);
  if (restaurantReverse === "A-Z") {
   tempdata = props.event && props.event.eventsReords.sort((a, b) => {
      
      if(a.user_details !== null && b.user_details !== null){
           if (a.user_details?.name < b.user_details?.name) return -1;
          if (a.user_details?.name > b.user_details?.name) return 1;
          return 0;
      }
     
    });
  } else if (restaurantReverse === "Z-A") {
    tempdata = props.event && props.event.eventsReords.sort((a, b) => {
      
      if(a.user_details !== null && b.user_details !== null){
        if (a.user_details?.name < b.user_details?.name) return 1;
       if (a.user_details?.name > b.user_details?.name) return -1;
       return 0;
   }
    });
  }


   tempdata = props?.event && props?.event?.eventsReords?.filter((data) =>{
      return(
        data?.user_id?.first_name?.toLowerCase().includes(state.search.toLowerCase())
      )
   });


  return (
    <React.Fragment>
      <div className="container-fluid superadmin-orderscomponent-main super-admin-vendor-private-orders">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                Event Report
                </div>
                <div>
                  <div className="f14-500 mb-2 d-flex justify-content-end align-items-end" style={{ color: "#EE3A23" }}>
                    {moment().format('lll')}
                  </div>
                  <RightSideCountTop
                    content={[
                      {
                        name: "Offline Events",
                        value: props?.event && props?.event?.offlineEvents,
                        backgroundColor: "#FFEDE9",
                        color: "#EE3A23",
                      },
                      {
                        name: (
                          <>
                            Online Events
                          </>
                        ),
                        value: props?.event && props?.event?.onlineEvents,
                        backgroundColor: "#EFEBFB",
                        color: "#6F32C9",
                      },
                      {
                        name: "Total Amount",
                        value: props?.event && props?.event?.totalEventsAmount ? <div>₹ {props?.event?.totalEventsAmount}</div>: null,
                        backgroundColor: "#D8F3F4",
                        color: "#138B90",
                      },
                    ]}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                    <Paper component="form" className="enSearch2 d-flex">
                      <IconButton type="submit" aria-label="search">
                        <SearchIcon />
                      </IconButton>
                      <InputBase
                        placeholder="Search"
                        name="search"
                        inputProps={{
                          "aria-label": "Search by Name or Phone Number",
                        }}
                        onChange={onSearchChange}
                        value={state.search}
                      />
                    </Paper>
                </div>
                <div className="col-3"></div>
                <div className="col-3">
                  <div className="mr-3">
                  <SelectFilter 
                      onDateChange={onDateChangeHandler()} 
                    />
                  </div>
                </div>
                <div className="col-2">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="f10-400" align="center">
                      <SortComponent
                        handleClick={handleClick}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        selectClick={(data) => handleSelect(data)}
                      />
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/filtericon.png")}
                        width="35px"
                      />
                      <br />
                      Filter
                    </div>
                    <div className="f10-400" align="center">
                      <img
                        src={require("../../../assets/images/iconButton/downloadicon.png")}
                        width="35px"
                      />
                      <br />
                      Download
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="col-12 p-0 user-table-reusable-superadmin table-responsive">
                  <Table className="HideShowTable enMinWidth900">
                    <thead style={{fontSize:'10px'}}>
                      <tr className="super_admin_all_users_table_head">
                        <th style={{ width: "300px" }} className="f12-700">
                        Event Type/ <br />
                        Event ID
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        User
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Event<br /> Status
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Total PAX/<br /> Ticket No.
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Table /<br /> Seat No
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Ticket <br />Total Amount
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        GST
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Service<br /> Charge (10%)
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        CC Charges
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Net Remitted
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Discount
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Donation
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Payment<br /> Status
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Payment Method/<br /> Transaction ID
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Hyperlink
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Event Joining <br />Code
                        </th>
                        <th style={{ width: "278px" }} className="f12-700">
                        Live stream <br />Viewed
                        </th>
                        
                      </tr>
                    </thead>
                    {props.auth.secondary_loader ? <SmallLoader/> : !isEmpty(tempdata) && tempdata.slice(start,end).map((data, index) => {
                      // console.log(data);
                    return ( 
                    <tbody>
                     
                      <tr key={index} className="super_admin_all_users_table_body">
                        <td style={{ width: "278px" }} className="f12-500">
                          <div className="super-admin-suggestion-table-body-boxone d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-400">
                                {data?.event_type}
                              </div>
                              <div className="f12-400">
                              {data?.event_request_id}
                            </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                          {data?.user_details?.name}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                          <div className="f12-500">{data?.event_status}</div>
                        {/* <div className="badge badge-success p-2">Completed</div> */}
                              <div className="f12-400">
                               {moment(data?.createdAt).format("YYYY-MM-DD")}
                              </div>
                              <div className="f12-400">
                               {moment(data?.createdAt).format("hh:mm:A")}
                              </div>
                            </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                          <div>{parseInt(data?.adult_count)+parseInt(data?.kids_count)} PAX/</div>
                          <div></div>
                          {data?.event_request_id}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        {/* {console.log(data?.seat_number)} */}
                        <div>{data?.table_number}</div>
                        {data?.seat_number && data?.seat_number.map((item)=>{
                          // console.log(item);
                          return(
                            <div>{item},</div>
                          )
                        })}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        ₹ {data?.payment_data && data?.payment_data?.total_amount}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        ₹ {data?.payment_data && data?.payment_data?.tax_charge}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        ₹ {data?.payment_data && data?.payment_data?.service_Charge}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        -
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        ₹ -
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        <div className="super-admin-suggestion-imageBoxTwo ml-2">
                          {data?.payment_status === 0 ? 
                              <div className="badge badge-warning p-2" style={{color:'white'}}>{PAYMENT_STATUS[data?.payment_status]}</div>
                          : null}
                          {data?.payment_status === 1 ? 
                              <div className="badge badge-success p-2" style={{color:'white'}}>{PAYMENT_STATUS[data?.payment_status]}</div>
                          : null}
                          {data?.payment_status === 2 ? 
                              <div className="badge badge-danger p-2" style={{color:'white'}}>{PAYMENT_STATUS[data?.payment_status]}</div>
                          : null}
                          {data?.payment_status === 3 ? 
                              <div className="badge badge-danger p-2" style={{color:'white'}}>{PAYMENT_STATUS[data?.payment_status]}</div>
                          : null}
                          {data?.payment_status === 4 ? 
                              <div className="badge badge-danger p-2" style={{color:'white'}}>{PAYMENT_STATUS[data?.payment_status]}</div>
                          : null}
                              <div className="f12-400">
                               {moment(data?.createdAt).format("YYYY-MM-DD")}
                              </div>
                              <div className="f12-400">
                               {moment(data?.createdAt).format("hh:mm:A")}
                              </div>
                            </div>
                          
                        </td>
                        <td style={{ width: "278px" }}>
                          <div className="f10-500">
                            <b>{PAYMENT_TYPE[data?.payment_data && data?.payment_data?.payment_method]}</b>
                          </div>
                          <div className="f9-400">
                            {data?.transactional_id}
                          </div>
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                          {data?.event_id?.eventLink}
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                       
                        </td>
                        <td style={{ width: "278px" }} className="f12-500">
                        
                        </td>
                      </tr>
                      
                    </tbody>
                    );
                  })}
                  </Table>
                </div>
              </div>

              <div className="p4v2-menu-pagination">
                <BasicPagination
                  totalRecords={props?.event?.eventsReords?.length}
                  limit={5}
                  batch={page}
                  onBatchChange={(e) => handleBatchChange(e)}
                />
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
       
      </div>
    </React.Fragment>
  );
}

EventReports.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  event: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  event: state.reports.eventReport,
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  Event_Reports,
})(EventReports);

// export default EventReports;
